import { Testimonial } from "./types";


export const testimonials: Testimonial[] = [
  {
    text: "Everyone needs more information about credit. I can say that, even though I spent many years teaching people how to build and repair credit. This world is constantly changing and ClientVitals can give you current information and the best step to take in your circumstance.",
    author: "Gillian F."
  },
  {
    text: "ClientVitals knows credit inside and out and can solve what seems like an unsolvable problem or unseemly barrier in a matter of minutes.",
    author: "Rachel B."
  },
  {
    text: "ClientVitals and its consultants are wizards at helping people solve their credit challenges. If you have an issue with your credit Jonathan and his team at ClientVitals will give you the help you need.",
    author: "Mike J."
  }
];

export const reviews: Testimonial[] = [
  {
    text: "As a single professional woman - I never thought I would get a house on my own, They helped me feel powerful and informed through the prep process of getting my credit ready for a mortgage.",
    author: "Christy, VT"
  },
  {
    text: "First I was a referral partner and then I became a client when I was denied for a mortgage myself, A tiny collection item was getting in the way, totally worth the 45 minute.",
    author: "Taz, NH."
  },
  {
    text: "After a messy divorce, I wanted the home I raised my children in, getting my credit ready and learning about mortgages was important to becoming a homeowner on my own, my consultant was kind and patient - Thanks Rory. ",
    author: "Seth, NY"
  }
];


